import { deliveryMethodIcons } from "@au-schein-de/au-ui-library";
import { EXPRESS_COURIER_PROVIDER } from "@dransay/api/models";
import type { ReactNode } from "react";

interface ExpressCourierMarkProps {
	provider?: string | null;
}

export function ExpressCourierMark({
	provider,
}: ExpressCourierMarkProps): ReactNode {
	if (provider === EXPRESS_COURIER_PROVIDER.LIEFERANDO) {
		return (
			<img
				src="/images/express-courier/lieferando-icon.png"
				alt=""
				width={24}
				height={24}
				className="size-6"
				data-testid="express-courier-lieferando-icon"
			/>
		);
	}
	if (provider === EXPRESS_COURIER_PROVIDER.UBER_DIRECT) {
		return (
			<img
				src="/images/express-courier/uber-logo.png"
				alt=""
				width={43}
				height={24}
				className="block h-6 w-[43px] object-contain"
				data-testid="express-courier-uber-icon"
			/>
		);
	}
	return deliveryMethodIcons.courier;
}
